import React from 'react'
import { THEME_CLASSIFIER_MODAL_DATA } from './constants'
import {
  Filters,
  FiltersProps,
  ThematicsSelect,
  PlacementCheckboxGroup,
  TargetingCheckboxGroup,
  PeriodDatePicker,
  FilterInputProps,
  CreativeCheckboxGroup
} from './components'

import * as Styled from './Filters.styled'

const FilterInputs: React.FC<FilterInputProps> = ({
  data,
  isFetching,
  formValues,
  availableDateRange,
  isCheckboxChecked,
  handleSelectChange,
  handleCheckboxChange,
  handleDateChange,
  handleOpenThemeClassifierModal
}) => (
  <>
    <ThematicsSelect
      options={data?.theme?.map(({ id, name }) => ({ value: id.toString(), label: name })) ?? []}
      value={formValues.theme}
      isDisabled={isFetching}
      label="theme"
      onChange={handleSelectChange}
      onTooltipLinkClick={handleOpenThemeClassifierModal}
    />
    <Styled.Item>
      <PlacementCheckboxGroup
        isDisabled={isFetching}
        isCheckboxChecked={isCheckboxChecked}
        onChange={handleCheckboxChange}
      />
      <TargetingCheckboxGroup
        isDisabled={isFetching}
        isCheckboxChecked={isCheckboxChecked}
        onChange={handleCheckboxChange}
      />
      <CreativeCheckboxGroup
        isDisabled={isFetching}
        isCheckboxChecked={isCheckboxChecked}
        onChange={handleCheckboxChange}
      />
    </Styled.Item>
    <PeriodDatePicker
      availableDateRange={availableDateRange}
      value={{
        min: formValues.min ? new Date(Number(formValues.min)) : undefined,
        max: formValues.max ? new Date(Number(formValues.max)) : undefined
      }}
      disabled={isFetching}
      onChange={handleDateChange}
    />
  </>
)

const TelegramAnalyticsFilters: React.FC<FiltersProps> = ({ data, isFetching, fetchData }) => {
  return (
    <Filters
      data={data}
      isFetching={isFetching}
      fetchData={fetchData}
      themeClassifierModalData={THEME_CLASSIFIER_MODAL_DATA}
      isNewGrid={true}
      methodologyModalData={{
        period: 'Обновляется ежемесячно',
        placement: <>Более 1 миллиона рекламных кампаний в Telegram Ads за&nbsp;указанный период</>,
        description: (
          <>
            Классификатор тематик рекламодателей составлен на базе категорий, которые присвоены
            каналам в TGStat. Присвоение тематики ботам осуществлялось вручную.
            <br />
            <br />
            Формулировки категорий таргетинга аналогичны категориям в рекламном кабинете Telegram
            Ads.
            <br />
            <br />
            Для показателей CPM, CPJ, CPS рассчитаны средневзвешенные значения.
          </>
        )
      }}
      FilterInputs={FilterInputs}
    />
  )
}

export default TelegramAnalyticsFilters
